import React from 'react';
import { connect } from 'react-redux';
import angular from 'angular';

export const connectWithStore =
  (...args) =>
  Wrapped => {
    // Create an intermediate redux-connected component
    const ConnectedWrapped = connect(...args)(Wrapped);

    // Take the instance of the store directly from the global Angular injector
    // and pass it manually for the component to use
    const ConnectedWrappedWithStore = props => {
      const store = angular.element(document).injector().get('$ngRedux');
      return <ConnectedWrapped store={store} {...props} />;
    };

    // Assign the same propTypes as the Wrapped component for react2angular bindings
    ConnectedWrappedWithStore.propTypes = Wrapped.propTypes;

    return ConnectedWrappedWithStore;
  };
